import React from 'react';
import TierPopup from '@wix/da-shared-react/pkg/TierPopup';

export interface Props {}

const SubscriptionsSection: React.FC<Props> = props => {
  return (
    <>
      <TierPopup requestClose={() => null} />
    </>
  );
};
SubscriptionsSection.displayName = 'SubscriptionsSection';

export default SubscriptionsSection;
